import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT } from "@/constants/contact";

export const PartnerBrb = () => (
  <section className="border-t border-border" data-testid="brb-partner-section">
    <div className="mx-auto max-w-4xl px-4 py-16">
      <p className="text-center text-sm font-semibold uppercase tracking-[0.25em] text-primary">
        Partenaire
      </p>
      <a
        href={CONTACT.brbImportLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="brb-partner-banner"
        className="mt-6 block overflow-hidden rounded-lg border border-border transition-colors hover:border-primary/60"
      >
        <img
          src="/images/brb-import.jpg"
          alt="BRB Import — import, courtage et dépôt-vente automobile, partenaire de MECA AUTO CLEAN 01"
          loading="lazy"
          className="w-full"
        />
      </a>
      <p className="mt-4 text-center text-sm text-muted-foreground">
        Import, courtage et dépôt-vente automobile : découvrez notre partenaire
        BRB Import.
      </p>
      <div className="mt-5 text-center">
        <Button asChild variant="outline" data-testid="brb-partner-cta">
          <a href={CONTACT.brbImportLink} target="_blank" rel="noopener noreferrer">
            <ExternalLink className="mr-2 h-4 w-4" /> Visiter brbimports.com
          </a>
        </Button>
      </div>
    </div>
  </section>
);
